export const DATE_FORMATS  ={
    'DD.MM.YYYY': 'DD.MM.YYYY'
}


export const TIME_FORMATS  ={
    'HH.mm': 'HH.mm'
}

export const DATE_TIME_FORMATS  ={
    'DD.MM.YYYY HH.mm A': 'DD.MM.YYYY HH.mm A'
}